var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFAF10"
    },
    cx: 256,
    cy: 256,
    r: 245
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.63,
    y: 379.83,
    style: {
      fill: "#445EA0"
    },
    width: 108,
    height: 46.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.63,
    y: 379.83,
    style: {
      fill: "#2E4C89"
    },
    width: 19.842,
    height: 46.17
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M333.134,450c0,2.75-2.25,5-5,5H129.131c-2.75,0-5-2.25-5-5v-20c0-2.75,2.25-5,5-5h199.003 c2.75,0,5,2.25,5,5V450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2B63"
    },
    d: "M143.973,450v-20c0-2.75,2.25-5,5-5h-19.842c-2.75,0-5,2.25-5,5v20c0,2.75,2.25,5,5,5h19.842 C146.223,455,143.973,452.75,143.973,450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M0,370.834c0,5.5,4.5,10,10,10h300.175v-66.951H0V370.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2B63"
    },
    d: "M19.842,370.834v-56.951H0v56.951c0,5.5,4.5,10,10,10h19.842 C24.342,380.834,19.842,376.334,19.842,370.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#445EA0"
    },
    d: "M310.175,286.987c0-2.206,1.794-4,4-4h143.09V66.465c0-6.046-4.946-10.992-10.991-10.992H10.992 C4.946,55.473,0,60.419,0,66.465v248.418h310.175V286.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF6FF"
    },
    d: "M310.175,286.987c0-2.206,1.794-4,4-4h121.107V82.457c0-2.75-2.25-5-5-5H26.984c-2.75,0-5,2.25-5,5 v205.441c0,2.75,2.25,5,5,5h283.19L310.175,286.987L310.175,286.987z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#445EA0"
    },
    cx: 228.63,
    cy: 348.21,
    r: 13.911
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M416.361,206.376c0,2.75-2.25,5-5,5H252.904c-2.75,0-5-2.25-5-5v-72.718c0-2.75,2.25-5,5-5h158.457 c2.75,0,5,2.25,5,5L416.361,206.376L416.361,206.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9518"
    },
    d: "M267.747,206.376v-72.718c0-2.75,2.25-5,5-5h-19.842c-2.75,0-5,2.25-5,5v72.718c0,2.75,2.25,5,5,5 h19.842C269.997,211.376,267.747,209.126,267.747,206.376z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M299.266,240.121h-43.112c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h43.112 c4.142,0,7.5,3.357,7.5,7.5S303.408,240.121,299.266,240.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M299.266,262.916h-43.112c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h43.112 c4.142,0,7.5,3.357,7.5,7.5S303.408,262.916,299.266,262.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M351.28,240.121h-32.06c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h32.06 c4.142,0,7.5,3.357,7.5,7.5S355.422,240.121,351.28,240.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M351.28,262.916h-32.06c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h32.06 c4.142,0,7.5,3.357,7.5,7.5S355.422,262.916,351.28,262.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M411.772,240.121h-40.836c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h40.836 c4.142,0,7.5,3.357,7.5,7.5S415.914,240.121,411.772,240.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M411.772,262.916h-40.836c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h40.836 c4.142,0,7.5,3.357,7.5,7.5S415.914,262.916,411.772,262.916z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF8318"
    },
    d: "M359.365,111.084c0,2.75-2.25,5-5,5h-10.999c-2.75,0-5-2.25-5-5v-10.999c0-2.75,2.25-5,5-5h10.999 c2.75,0,5,2.25,5,5V111.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF8318"
    },
    d: "M387.363,111.084c0,2.75-2.25,5-5,5h-10.999c-2.75,0-5-2.25-5-5v-10.999c0-2.75,2.25-5,5-5h10.999 c2.75,0,5,2.25,5,5V111.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF8318"
    },
    d: "M415.361,111.084c0,2.75-2.25,5-5,5h-10.999c-2.75,0-5-2.25-5-5v-10.999c0-2.75,2.25-5,5-5h10.999 c2.75,0,5,2.25,5,5V111.084z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M190.898,257.005h-9c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h9c4.142,0,7.5,3.357,7.5,7.5 C198.398,253.648,195.04,257.005,190.898,257.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M156.898,257.005h-9c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h9c4.142,0,7.5,3.357,7.5,7.5 C164.398,253.648,161.04,257.005,156.898,257.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M122.897,257.005h-9c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h9c4.142,0,7.5,3.357,7.5,7.5 C130.398,253.648,127.04,257.005,122.897,257.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M88.897,257.005h-9c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h9c4.142,0,7.5,3.357,7.5,7.5 C96.397,253.648,93.04,257.005,88.897,257.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M220.148,226.106c-4.142,0-7.5-3.357-7.5-7.5v-9c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v9 C227.648,222.749,224.29,226.106,220.148,226.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M220.148,192.106c-4.142,0-7.5-3.357-7.5-7.5v-9c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v9 C227.648,188.749,224.29,192.106,220.148,192.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M220.148,158.106c-4.142,0-7.5-3.357-7.5-7.5v-9c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v9 C227.648,154.749,224.29,158.106,220.148,158.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M50.147,226.106c-4.142,0-7.5-3.357-7.5-7.5v-9c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v9 C57.647,222.749,54.29,226.106,50.147,226.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M50.147,192.106c-4.142,0-7.5-3.357-7.5-7.5v-9c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v9 C57.647,188.749,54.29,192.106,50.147,192.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M50.147,158.106c-4.142,0-7.5-3.357-7.5-7.5v-9c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v9 C57.647,154.749,54.29,158.106,50.147,158.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M190.898,121.005h-9c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h9c4.142,0,7.5,3.357,7.5,7.5 S195.04,121.005,190.898,121.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M156.898,121.005h-9c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h9c4.142,0,7.5,3.357,7.5,7.5 S161.04,121.005,156.898,121.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M122.897,121.005h-9c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h9c4.142,0,7.5,3.357,7.5,7.5 S127.04,121.005,122.897,121.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M88.897,121.005h-9c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h9c4.142,0,7.5,3.357,7.5,7.5 S93.04,121.005,88.897,121.005z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M200.148,224.505c0,2.75-2.25,5-5,5h-120c-2.75,0-5-2.25-5-5v-86c0-2.75,2.25-5,5-5h120 c2.75,0,5,2.25,5,5V224.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28A5A5"
    },
    d: "M89.99,224.505v-86c0-2.75,2.25-5,5-5H75.147c-2.75,0-5,2.25-5,5v86c0,2.75,2.25,5,5,5H94.99 C92.24,229.505,89.99,227.255,89.99,224.505z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#52BBEF"
    },
    d: "M234.145,121.009c0,2.75-2.25,5-5,5h-21c-2.75,0-5-2.25-5-5v-21c0-2.75,2.25-5,5-5h21 c2.75,0,5,2.25,5,5V121.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#52BBEF"
    },
    d: "M68.145,123.009c0,2.75-2.25,5-5,5h-21c-2.75,0-5-2.25-5-5v-21c0-2.75,2.25-5,5-5h21 c2.75,0,5,2.25,5,5V123.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#52BBEF"
    },
    d: "M234.145,260.883c0,2.75-2.25,5-5,5h-21c-2.75,0-5-2.25-5-5v-21c0-2.75,2.25-5,5-5h21 c2.75,0,5,2.25,5,5V260.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#52BBEF"
    },
    d: "M68.145,260.883c0,2.75-2.25,5-5,5h-21c-2.75,0-5-2.25-5-5v-21c0-2.75,2.25-5,5-5h21 c2.75,0,5,2.25,5,5V260.883z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E99D6"
    },
    d: "M214.167,121.009v-21c0-2.75,2.25-5,5-5h-11.022c-2.75,0-5,2.25-5,5v21c0,2.75,2.25,5,5,5h11.022 C216.417,126.009,214.167,123.759,214.167,121.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E99D6"
    },
    d: "M48.167,123.009v-21c0-2.75,2.25-5,5-5H42.145c-2.75,0-5,2.25-5,5v21c0,2.75,2.25,5,5,5h11.022 C50.417,128.009,48.167,125.759,48.167,123.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E99D6"
    },
    d: "M214.167,260.883v-21c0-2.75,2.25-5,5-5h-11.022c-2.75,0-5,2.25-5,5v21c0,2.75,2.25,5,5,5h11.022 C216.417,265.883,214.167,263.633,214.167,260.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E99D6"
    },
    d: "M48.167,260.883v-21c0-2.75,2.25-5,5-5H42.145c-2.75,0-5,2.25-5,5v21c0,2.75,2.25,5,5,5h11.022 C50.417,265.883,48.167,263.633,48.167,260.883z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M435.458,366.773c-0.155-0.422-0.143-0.662-0.121-0.74c0.001,0,0.062-0.006,0.119-0.006 c0.114,0,0.313,0.023,0.614,0.134l42.104,15.465v-94.638c0-2.75-2.25-5-5-5h-159c-2.75,0-5,2.25-5,5v114.8c0,2.75,2.25,5,5,5h135.98 L435.458,366.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28A5A5"
    },
    d: "M329.017,401.787v-114.8c0-2.75,2.25-5,5-5h-19.842c-2.75,0-5,2.25-5,5v114.8c0,2.75,2.25,5,5,5 h19.842C331.267,406.787,329.017,404.537,329.017,401.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M436.415,365.222c-1.647-0.605-2.501,0.248-1.896,1.896l26.365,71.782 c0.605,1.648,2.116,1.98,3.357,0.739l13.997-13.997c1.241-1.241,3.272-1.241,4.515,0l16.128,16.13c1.241,1.241,3.272,1.241,4.514,0 l7.674-7.674c1.241-1.241,1.241-3.273,0-4.514l-16.129-16.129c-1.241-1.241-1.241-3.272,0-4.514l13.996-13.997 c1.242-1.24,0.909-2.751-0.739-3.356L436.415,365.222z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUx);
export default __webpack_public_path__ + "static/media/ux.7b9df4cc9342f30348a6f357f0b7f748.svg";
export { ForwardRef as ReactComponent };